<template>
    <div class="container">
        <router-view></router-view>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";

    @Component
    export default class AdminHome extends Vue{
    }
</script>

<style scoped>
</style>
